export const MAIN_PAGE = Symbol("brxmMainPage");
